import { PrizeTypes } from "../brandVariables.types";

export const legoPrize: PrizeTypes = {
  content: "Slå Johnni’s tid og du er med i lodtrækningen om et",
  nameOf: "Logitech G A50 X McLaren Edition ", // will be marked in color
  typeOfItem: "trådløst gaming-headset til en værdi af 2.699,00 kr.", // will be added after nameOf
};
